import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class SchedulesIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      current: '',
      next: '',
      previous: '',
      show_fleet: 0,
      show_base: 0,
      user_type: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.exportPdfGrade = this.exportPdfGrade.bind(this);
    this.loadData = this.loadData.bind(this);
    this.loadOrigin = this.loadOrigin.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.apiOrigin = this.apiOrigin.bind(this);
    this.personalFields = this.personalFields.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadOrigin());
    }
  }

  loadData(reference) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    if (this.state.user_type === 'sigtrip') {
      var api = 'api';
    }
    else if (this.state.user_type === 'sigmec') {
      var api = 'api_sigmec';
    }
    Promise.resolve(header).then(function(value) {
      var url = config.get(api) + '/funcionario/escalas/' + reference;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next});
          self.personalFields(responseJson.data.fleet, responseJson.data.base);
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  loadOrigin() {
    var now = new Date();
    var month = (now.getMonth()) + 1;
    var year = now.getFullYear();
    var reference = month + '/' + year;
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/checar/origem/usuario';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.apiOrigin(responseJson.data);
          self.loadData(reference);
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }); /* Overlay */
    });
  }

  apiOrigin(origin) {
    this.setState({user_type: origin});
  }

  ActionsButtons (event) {
    var schedule_grade_id = this.state.data[0].schedule_grade_id;
    var revision = this.state.data[0].schedule_grade_revision;
    var botao = (
      <div>
        <button onClick={this.exportPdfGrade} className="btn btn-warning button-inline" value={schedule_grade_id}><i className="fa fa-fw fa-file-pdf-o"></i> {this.locale.Escalas.ListaDeEscalas.botaoRevisao} {revision}</button>
      </div>
    );

    return botao;
  }

  personalFields (fleet, base) {
    this.setState({show_fleet: fleet, show_base: base});
  }

  exportPdfGrade(event) {
    var schedule_grade_id = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    if (this.state.user_type === 'sigtrip') {
      var api = 'api';
      var cdn = 'cdn';
      var route = '/exportar/pdf/escala-grade/' + schedule_grade_id;
      var pdf = '/schedule_grades/main/';
    }
    else if (this.state.user_type === 'sigmec') {
      var api = 'api_sigmec';
      var cdn = 'cdn_sigmec';
      var route = '/exportar/escala/grade/visualizar/' + schedule_grade_id + '/2';
      var pdf = '/tmp/';
    }
    Promise.resolve(header).then(function(value) {
      var url = config.get(api) + route;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        window.open(config.get(cdn) + pdf + responseJson.data);
      })
    });
  }

  next() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.next);
  }

  previous() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.previous);
  }

  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-primary" onClick={this.previous}><i className="fa fa-fw fa-chevron-left"></i> {this.state.previous}</button>
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.current}</h3>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-primary" onClick={this.next}>{this.state.next} <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.Escalas.ListaDeEscalas.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Escalas.ListaDeEscalas.tabela.semEscalasEsteMes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Escalas.ListaDeEscalas.tabela.ID}</TableHeaderColumn>
        {(this.state.show_fleet == 1) &&
          <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Escalas.ListaDeEscalas.tabela.Frota}</TableHeaderColumn>
        }
        {(this.state.show_base == 1) &&
          <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Escalas.ListaDeEscalas.tabela.Base}</TableHeaderColumn>
        }
        <TableHeaderColumn dataField="reference" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Escalas.ListaDeEscalas.tabela.Referencia}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='200'>{this.locale.Escalas.ListaDeEscalas.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default SchedulesIndex;


// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulesIndex.js